<template lang="pug">
.coupons-container
  .bussiness-ladder(v-if="ladderNum") {{`完成${ladderNum}单（${coupons.length}选1）`}}
  .bussiness-coupons-container(:class=" ladderNum ? 'multi' : '' ")
    .bussiness-coupons(v-for="(item, index) in coupons")
      .bussiness-line-block-card-block
        .bussiness-block-info
          .big-word-font {{(item.propType!==4&&item.propType!==7)?item.amount:item.propTimes}}
          .small-word-font {{(item.propType!==4&&item.propType!==7)?item.unit:'次'}}
        .bussiness-block-middle-info {{item.subtitle}}
        .bussiness-block-bottom-info {{getWord(item)}}
</template>
<script>
export default {
  props: {
    coupons: {
      type: Array,
      required: true,
    },
    ladderNum: {
      type: Number,
      required: false,
      default: undefined,
    },
    tempObj: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
    };
  },
  methods: {
    getWord(val) {
      if (this.ladderNum) {
        return `${val.goodsPropDesc || ''}`;
      }
      if (this.tempObj.unOpenProgressDesc) {
        return this.tempObj.unOpenProgressDesc.replace('%s', val.ladderNum);
      }
      return '';
    },
  },
};
</script>
<style lang="less" scoped>
.coupons-container {
  padding: 0 0.1rem;
  margin-bottom: 0.14rem;

  &:last-child {
    margin-bottom: 0;
  }

  .bussiness-ladder {
    margin: 0 0 0.08rem 0.04rem;
    height: 0.18rem;
    font-family: PingFang SC, sans-serif;
    font-size: 0.13rem;
    font-weight: 400;
    line-height: 0.18rem;
    text-align: left;
    color: #531900;
  }

  .bussiness-coupons-container {
    display: flex;

    .bussiness-coupons {
      width: 0.78rem;
      height: 0.91rem;
      background-image: url(https://m.hellobike.com/resource/helloyun/08345/J5pWn0JUc3.png);
      background-size: 100% 100%;
      margin-right: 0.06rem;

      .bussiness-block-info {
        text-align: center;
        display: flex;
        justify-content: center;

        .big-word-font {
          height: 0.3rem;
          margin-top: 0.03rem;
          font-size: 0.26rem;
          font-family: DINAlternate-Bold, DINAlternate, sans-serif;
          font-weight: bold;
          color: #f54311;
          line-height: 0.3rem;
        }

        .small-word-font {
          margin-top: 0.12rem;
          font-size: 0.11rem;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          color: #f54311;
          margin-left: 0.01rem;
        }
      }

      .bussiness-block-middle-info {
        text-align: center;
        font-size: 0.11rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        color: #b16652;
        line-height: 0.16rem;
      }

      .bussiness-block-bottom-info {
        text-align: center;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 600;
        color: #fef8ea;
        line-height: 20px;
        margin-top: 0.16rem;
      }
    }
  }

  .multi {
    .bussiness-coupons {
      width: 0.63rem;
      height: 0.72rem;
      margin-right: 0.04rem;

      .bussiness-block-info {
        .big-word-font {
          height: 0.2rem;
          margin-top: 0.06rem;
          font-size: 0.2rem;
          line-height: 0.2rem;
        }

        .small-word-font {
          margin-top: 0.16rem;
          height: 0.09rem;
          line-height: 0.09rem;
        }
      }

      .bussiness-block-middle-info {
        margin-top: 0.02rem;
        font-size: 0.09rem;
        height: 0.13rem;
        line-height: 0.13rem;
      }

      .bussiness-block-bottom-info {
        height: 0.13rem;
        line-height: 0.13rem;
        margin-top: 0.11rem;
        font-size: 0.12rem;
      }
    }
  }
}
</style>
